<template>
  <b-row class="fs-12">
    <h6 class="pl-12 pt-20 fs-20 title-color">
      <b>TextArea options</b>
    </h6>
    <b-row class="pt-18 mb-20">
      <b-col cols="12" class="fw-bold mb-10" align-self="center">
        Field Requirement.
      </b-col>
      <b-col align-self="center">
        <b-form-checkbox @change="formTextAreaData.required = !formTextAreaData.required" v-model="formTextAreaData.required" class="pl-0"> <span class="pl-25 text-align fs-15">Required</span> </b-form-checkbox><br />
      </b-col>
    </b-row>
    <b-row class="pb-12">
      <b-col cols="12">
        <hr />
      </b-col>
      <b-col cols="12" class="fw-bold mt-20 fs-12">
        Field Name
      </b-col>
      <b-col cols="12" class="pt-10 fs-15">
        You may name this field for the purposes of data mapping. It will not be visible to the Site Team(s) or participants.
      </b-col>
      <b-col cols="12 pt-12">
        <b-form-input type="text" v-model="formTextAreaData.fieldName" placeholder="Enter field name" class="field-h40 form-control fs-15" size="sm" v-bind:class="{ 'is-danger': formTextAreaData.fieldNameErrorMsg }" v-on:keyup.native="checkForErrors" autocomplete="off"></b-form-input>
        <span class="error-style" v-if="formTextAreaData.fieldNameErrorMsg">{{ formTextAreaData.fieldNameErrorMsg }}</span>
      </b-col>
    </b-row>
  </b-row>
</template>

<script>
import _ from "lodash";

export default {
  name: "form-text-area-prop",
  components: {},
  data() {
    return {
      formTextAreaData: [],
      choicesGiven: [],
      hideAddNotification: true,
      notifications: [],
      notificationSchema: {
        name: "Notification",
        mode: false,
        choiceSelected: "",
        contacts: [],
        thresholdFalg: false,
        threshold: {
          minLimitFlag: true,
          minValue: 0,
          maxLimitFlag: true,
          maxValue: 250
        }
      },
      choicesToShow: ["If an answer is provided", "If an answer is not provided"]
    };
  },
  props: ["formTextAreaSchema"],
  mounted() {
    this.formTextAreaData = this.formTextAreaSchema;
    this.notifications = this.formTextAreaData.notifications;
  },
  computed: {},
  methods: {
    addNewNotification() {
      const notificationSchema = _.cloneDeep(this.notificationSchema);
      notificationSchema.name = `${notificationSchema.name} ${this.formTextAreaData.notifications.length + 1}`;
      this.notifications.push(notificationSchema);
      this.hideAddNotification = !this.hideAddNotification;
    },

    saveNotification() {
      this.formTextAreaData.notifications = this.notifications;
    },

    removeNotification(index) {
      this.formTextAreaData.notifications.splice(index, 1);
    },

    showThreshold(notification) {
      const data = notification;
      if (notification.choiceSelected === "If answer violates a set threshold") {
        data.thresholdFalg = true;
      } else {
        data.thresholdFalg = false;
      }
    },

    checkForErrors() {
      if (this.formTextAreaData.fieldName && this.formTextAreaData.fieldName.trimEnd().length > 0) {
        this.formTextAreaData.fieldNameErrorMsg = "";
      }
    }
  }
};
</script>

<style scoped lang="scss">
.notificationBorder {
  border-radius: 3px;
  border: 0.5px solid lightgrey;
  padding: 8px;
}

.error-style {
  font-size: 12px;
  color: #ff4848;
  padding-bottom: 5px;
}

.is-danger {
  border-color: #ff4848;
}

.text-align {
  line-height: 23px !important;
}

.lh-3 {
  line-height: 3 !important;
}

.lh-1 {
  line-height: 1 !important;
}

.notifyButton {
  font-size: 10px;
  padding: 5px 6px 5px 6px;
  font-weight: 900;
}

/deep/.vue-switcher-theme--custom.vue-switcher-color--blue div {
  background-color: #1e8fe1;
  height: 9px;
  width: 33px;
}

/deep/.vue-switcher-theme--custom.vue-switcher-color--blue div:after {
  background-color: #ffffff;
  border: 1px solid #1e8fe1;
  height: 15px;
  width: 15px;
  margin-left: -15px;
}

/deep/.vue-switcher-theme--custom.vue-switcher-color--blue.vue-switcher--unchecked div {
  background-color: #d5d7dc;
  height: 9px;
  width: 33px;
}

/deep/.vue-switcher-theme--custom.vue-switcher-color--blue.vue-switcher--unchecked div:after {
  background-color: #ffffff;
  border: 1px solid #1e8fe1;
  height: 15px;
  width: 15px;
}
</style>
